<spinner [visible]="progressVisible" [pleaseWaitText]="t.common('please_wait')"></spinner>

<div class="fixed-header hw-width-100">
  <div class="form-container">
    @if (loaded) {
    <div class="header-style hw-block">
      <div>
        @if (subscriberInfo) {
        <div class="hw-left" id="header" fxLayoutAlign="start center">
          @if (!isMobile && logoPath) {
          <div class="img" fxLayoutAlign="center center">
            <img class="logo" src={{logoPath}} height="50" alt="">
          </div>
          }
          <button class="subscriber-name hw-cursor accessibility-button"
                  [matTooltip]="sessionStorageService.getReturnUrl() ? ('shopping.back_to_dealer_website' | translate): undefined"
                  aria-describedby="{{getSubscriberName()}}" tabindex="0" aria-label="{{getSubscriberName()}}"
                  (click)="backToDealerWebsite()">
            {{getSubscriberName()}}
          </button>
        </div>
        }
      </div>
      <div fxLayoutAlign="end center">
        @if (!isMobile && languageSelectorItems.length>1) {
        <div class="hw-left" fxLayoutAlign="center center">
          @for (language of languageSelectorItems; track language) {
          <button class="hw-display-inline-block accessibility-button" matTooltip="{{language.customName}}"
                  aria-label="{{language.customName}}">
            @if (selectedLanguageCode != language.code) {
            <a (click)="changeLanguage(language.code)" class="hw-cursor-pointer">
              <img [src]="language.flagUrl" height="15" width="24" class="flag-design" alt="" />
            </a>
            }
            @if (selectedLanguageCode == language.code) {
            <img [src]="language.flagUrl" height="25" width="35" class="flag-design" alt="" />
            }
          </button>
          }
        </div>
        }
        @if (isMobile && languageSelectorItems.length>1) {
        <div class="hw-left hw-padding-top-5px hw-cursor-pointer" (click)="showLanguageSelector()">
          <img [src]="getSelectedLanguageObject().flagUrl" height="15" width="24" class="flag-design flag-border"
               alt="" />
        </div>
        }
        @if (basketIconVisible()) {
        <button class="accessibility-button basket-position cart-background" tabindex="0"
                (click)="this.basketService.isAnyItemInBasket()? goToBasket() : null"
                [ngStyle]="{'opacity':!this.basketService.isAnyItemInBasket() ? '0.3' : 'unset' }"
                matTooltip="{{t.errors('ERR_BASKET')}}"
                [matTooltipDisabled]="!this.basketService.isAnyItemInBasket() || basketService.isBasketValid()"
                fxLayoutAlign="center center">
          <mat-icon class="mdi mdi-cart cart-icon {{getBasketBadgeCssClass()}}" fxLayoutAlign="center center"
                    matBadge={{ticketsCount()}}></mat-icon>
        </button>
        }
        <button class="accessibility-button accessibility" (click)="toggleAccessibilityButton()">
          <img src="assets/accessibility.png" alt="" width="35">
        </button>
      </div>
    </div>
    }
  </div>
</div>

<div class="form-container">
  @if (loaded) {
  <div class="hw-block">
    <div fxFlex="row">
      <div fxFlex="leftSideFlex()" class="left-side-area">
        <div fxLayout="row">
          <div fxLayoutAlign="center" fxFlex="100">
          </div>
        </div>
        <div fxLayout="row" class="hw-padding-bottom-1em">
          @let stepi = stepIndex();
          <div fxFlex="100" fxLayoutAlign="center center">
            <div class="step-wrapper">
              <span class="current-step" style="font-weight: bold;">{{stepi}}</span> <span class="slash">/</span><span class="max-steps">{{maxSteps}}</span>
              <button id="Pager" onclick="window.scrollTo(0, 0)" class="hw-position-absolute right-100000"
                      aria-label="button"></button>
            </div>
            <div class="stepper-label-group">
                <h3>{{stepName()}}</h3>
                @if(stepi > 1 &&  stepi< 5){
                    <span class="hw-font-size-18px hw-font-weight-700">{{selectedDate | date:'shortDate':undefined:currLocale}}</span>
                }                
            </div>
            @if (activeStep == 3) {
            <span class="mdi mdi-information-outline more-description hw-margin-left-10px"
                  (click)="dialogService.showMessageList(getTicketByInformationText(), t.shopping('ticket_sale_information_header'))">
            </span>
            }
          </div>
        </div>
        <div fxLayout="row" class="hw-padding-bottom-1em">
          <div fxLayoutAlign="center" fxFlex="100">
            @if (getSelectedAreaName()) {
            <div>
              <span class="area-name-header" [innerHTML]="getSelectedAreaName() | safeHtml"></span>
            </div>
            }
          </div>
        </div>
        <!-- PAGE #1: Date selection -->
        @if ((activeStep == 0)) {
        <div>
          <div fxLayout="column" fxLayoutAlign="center center">
            <div fxFlex="100">
              <ng-container [ngTemplateOutlet]="date_selection" class=""></ng-container>
            </div>
          </div>
          <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" class="bottom-fixed">
            <button mat-raised-button (click)="selectDate()"
                    class="hw-step-button-margin custom-next-button hw-width-100 mat-step-buttons">
              <mat-icon iconPositionEnd class="mdi mdi-chevron-right"></mat-icon> {{t.common("next")}}
            </button>
          </div>
          @if (logoPath) {
          <div class="img" fxLayoutAlign="center center">
            <img class="logo" src={{logoPath}} height="248" alt="">
          </div>
          }
          <div class="hw-div-center">
            <mat-card appearance="outlined" class="sop-mat-card" fxLayoutAlign="center center">
              <mat-card-content class="hw-padding-top-0">
                <div class="group-header">
                  {{t.shopping("ticket_sale_information_header")}}
                </div>
                @let ticketSalesForManyDay = getSettingValue("TicketSalesForManyDay");
                <div fxLayout="row wrap">
                  <div class="hw-width-100 input-field-style">
                    <strong>{{t.shopping("max_ticket_sales_by_day")}}:</strong>
                    {{getSettingValue("MaxTicketSalesByDay")}}
                  </div>
                </div>

                @if(ticketSalesForManyDay){
                  <div fxLayout="row wrap">
                    <div class="hw-width-100 input-field-style">
                      <strong>{{t.shopping("max_ticket_sales_by_basket")}}:</strong>
                      {{getSettingValue("MaxTicketSalesByBasket")}}
                    </div>
                  </div>
                }

                <div fxLayout="row wrap">
                  <div [style]="canUserBuyTicketForToday? '': 'color:red'" class="hw-width-100 input-field-style">
                    <strong class="hw-font-size-18px">{{t.shopping("ticket_sales_for_actual_day")}}:</strong> {{getTicketSalesForActualDayText()}}
                  </div>
                </div>

                @if(ticketSalesForManyDay){
                <div fxLayout="row wrap">
                  <div class="hw-width-100 input-field-style">
                    <strong>{{t.shopping("ticket_sales_for_many_day")}}</strong>                    
                  </div>
                </div>
                }

                @if(subscriberInfo && subscriberInfo.contacts && subscriberInfo.contacts.PhoneNumber){
                <div class="tel-header hw-border-top">
                  <p>{{t.shopping("support")}}:</p>
                  <a mat-raised-button class="hw-mat-tel-btn" [href]="'tel:' + subscriberInfo.contacts.PhoneNumber">
                    <mat-icon>phone</mat-icon>
                    {{subscriberInfo.contacts.PhoneNumber}}
                  </a>
                </div>
                }

              </mat-card-content>
            </mat-card>
          </div>
          <br /><br /><br />
        </div>
        }
        <!-- PAGE #2: Area selection -->
        @if (activeStep===1) {
        <div>
          <div fxLayout="row">
            <div fxFlex="100">
              <ng-container [ngTemplateOutlet]="area_selection"></ng-container>
            </div>
          </div>
          <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" class="bottom-fixed">
            <div class="hw-step-button-margin">
              <button mat-raised-button color="accent" class="mat-step-buttons" (click)="previousStep()">
                <mat-icon class="mdi mdi-chevron-left"></mat-icon> {{t.common("back")}}
              </button>
            </div>
            <!-- ÚJ TOVÁBB GOMB -->
            <div class="hw-step-button-margin">
              @if (basketService.isAnyItemInBasket()) {
              <button mat-raised-button color="primary" (click)="goToBasket()"
                      class="custom-next-button mat-step-buttons">
                <mat-icon iconPositionEnd class="mdi mdi-chevron-right"></mat-icon> {{t.common("next")}}
              </button>
              }
            </div>
          </div>
        </div>
        }
        <!-- PAGE #3: Group selection -->
        @if (activeStep===2) {
        <div>
          <div fxLayout="row">
            <div fxFlex="100">
              <ng-container [ngTemplateOutlet]="group_selection"></ng-container>
            </div>
          </div>
          <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" class="bottom-fixed">
            <div class="hw-step-button-margin">
              <button mat-raised-button color="accent" class="mat-step-buttons" (click)="previousStep()">
                <mat-icon class="mdi mdi-chevron-left"></mat-icon> {{t.common("back")}}
              </button>
            </div>
            <!-- ÚJ TOVÁBB GOMB -->
            <div class="hw-step-button-margin">
              @if (basketService.isAnyItemInBasket()) {
              <button mat-raised-button color="primary" (click)="goToBasket()"
                      class="custom-next-button mat-step-buttons">
                <mat-icon iconPositionEnd class="mdi mdi-chevron-right"></mat-icon> {{t.common("next")}}
              </button>
              }
            </div>
          </div>
        </div>
        }
        <!-- PAGE #4: Ticket selection -->
        @if (activeStep === 3) {
        <div>
          <div fxLayout="row wrap" fxLayoutGap="10px">
            <div fxFlex="100">
              <ng-container [ngTemplateOutlet]="ticket_selection"></ng-container>
            </div>
          </div>
          <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" class="bottom-fixed">
            <div class="hw-step-button-margin">
              <button mat-raised-button color="accent" class="hw-width-100 mat-step-buttons" (click)="backFromTicket()">
                <mat-icon class="mdi mdi-chevron-left"></mat-icon> {{t.common("back")}}
              </button>
            </div>
            <div class="hw-step-button-margin">
              @if (basketService.isAnyItemInBasket()) {
              <button mat-raised-button (click)="goToBasket()" class="custom-next-button hw-width-100 mat-step-buttons">
                <mat-icon iconPositionEnd class="mdi mdi-chevron-right"></mat-icon> {{t.common("next")}}
              </button>
              }
            </div>
          </div>
        </div>
        }
        <!-- PAGE #5: Show basket -->
        @if (activeStep===4) {
        <div>
          <div fxLayout="row">
            <div fxFlex="100">
              <ng-container [ngTemplateOutlet]="show_basket"></ng-container>
            </div>
          </div>
          <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" class="bottom-fixed">
            <div class="hw-step-button-margin">
              <button mat-raised-button color="accent" (click)="previousStep()" class="hw-width-100 mat-step-buttons">
                <mat-icon class="mdi mdi-chevron-left"></mat-icon>
                {{t.common("back")}}
              </button>
            </div>
            <div class="hw-step-button-margin">
              @if (basketService.isBasketValid()) {
              <button mat-raised-button color="primary" (click)="gotoInvoiceData()"
                      class="hw-width-100 custom-next-button mat-step-buttons">
                <mat-icon iconPositionEnd class="mdi mdi-chevron-right"></mat-icon> {{t.common("next")}}
              </button>
              }
            </div>
          </div>
        </div>
        }
        <!-- PAGE #6: invoice data -->
        @if (activeStep === 5) {
        <div>
          <div fxLayout="row">
            <div fxFlex="100">
              <ng-container *ngTemplateOutlet="personal_data; context:{form: personalDataForm}"></ng-container>
            </div>
          </div>
          <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" class="bottom-fixed">
            <div class="hw-step-button-margin">
              <button mat-raised-button color="accent" class="hw-width-100 mat-step-buttons" (click)="previousStep()">
                <mat-icon class="mdi mdi-chevron-left"></mat-icon>
                {{t.common("back")}}
              </button>
            </div>
            <div class="hw-step-button-margin">
              <button [ngStyle]="{'opacity':!personalDataForm.valid ? '0.5' : 'unset' }"
                      [disabled]="!personalDataForm.valid" mat-raised-button (click)="gotoSummary()"
                      class="custom-next-button hw-width-100 mat-step-buttons">
                <mat-icon iconPositionEnd class="mdi mdi-chevron-right"></mat-icon> {{t.common("next")}}
              </button>
            </div>
          </div>
          <br /><br /><br />
        </div>
        }
        <!-- PAGE #7: Summary -->
        @if (activeStep === 6) {
        <div>
          <div fxLayout="row">
            <div fxFlex="100">
              <ng-container *ngTemplateOutlet="summary; context:{form: summaryForm}"></ng-container>
            </div>
          </div>
          <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" class="bottom-fixed">
            <div class="hw-step-button-margin">
              <button mat-raised-button color="accent" class="hw-width-100 mat-step-buttons" (click)="previousStep()">
                <mat-icon class="mdi mdi-chevron-left"></mat-icon> {{t.common("back")}}
              </button>
            </div>
            <div class="hw-step-button-margin">
              <button [ngStyle]="{'opacity':!summaryForm.valid ? '0.5' : 'unset' }" [disabled]="!summaryForm.valid"
                      mat-raised-button (click)="gotoPayment()" class="custom-next-button hw-width-100 mat-step-buttons">
                <mat-icon iconPositionEnd class="mdi mdi-chevron-right"></mat-icon> {{t.common("payment")}}
              </button>
            </div>
          </div>
          <br /><br /><br />
        </div>
        }
      </div>
    </div>
  </div>
  }
</div>

<ng-template #date_selection>
  <mat-form-field class="date-mobile-position" appearance="outline">
    <input matInput aria-label="datepicker" for="picker" [matDatepicker]="picker" [formControl]="dateSelectionCtl"
           [min]="minDate" [max]="maxDate" (dateChange)="selectDateChanged($event.value)" class="date-mobile-position">
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker [touchUi]="isMobile" [dateClass]="dateClass" disabled="false"
                    [calendarHeaderComponent]="customCalendarHeader" class="hw-width-100">
    </mat-datepicker>
  </mat-form-field>
</ng-template>

<ng-template #area_selection>
  <div class="hw-block hw-100">
    <div fxFlex fxLayout="row" fxLayout.xs="column" fxLayout.sm="column">
      <div fxFlex="100">
        <mat-grid-list class="hw-100" [cols]="isMobile ? 1 : isTablet ? 2 : 4" gutterSize="10px" rowHeight="235px">
          @for (area of areaList; track area) {
          <mat-grid-tile>
            @if (isAreaDisabled(area)) {
            <div fxFlex="70" fxFlexAlign="center center" class="area-error-container hw-padding-1em">
              {{t.errors("ERR_ALL_TICKET_SOLD")}}
            </div>
            }
            <div class="mat-elevation-z8 area-card area-card-style"
                 [ngStyle]="{'opacity': isAreaDisabled(area) ? '0.3' : '' }">
              <!-- line 1 -->
              <div fxLayout="row" class="hw-100">
                <div fxFlex="100" fxLayout="row" class="area-icon-container hw-width-100">
                  <div fxFlex="20"></div>
                  <div fxFlex="60" class="image-wrapper">
                    <img src={{getAreaImagePath(area)}} class="areakind-icon-style" alt="">
                  </div>
                  <span fxFlex="20" class="mdi mdi-information-outline more-description"
                        (click)="!isAreaDisabled(area) && area.language.description ? showTooltip(area.language.description) : null"
                        class="hw-margin-left-auto" [ngStyle]="{'opacity': area.language.description ? '' : '0.3' }">
                    <span class="mdi mdi-information-outline more-description"></span>
                  </span>


                </div>
              </div>
              <!-- line 2 -->
              <div fxLayout="row">
                <div fxFlex="100" fxFlexAlign="center" class="area-name-container hw-width-100">
                  <span class="area-name-font">{{area.language.name}}</span>
                </div>
              </div>
              <!-- line 3 -->
              <div fxLayout="row">
                <div fxFlex="100" fxFlexAlign="center" class="area-name-container hw-width-100">
                  <!--<span [ngStyle]="areFullNessStyle(area.occupancy)" class="capacity-name-font">{{areFullNessText(area.occupancy)}}</span>-->
                </div>
              </div>
              <!-- line 4 -->
              <div fxLayout="row">
                <div fxFlex="100" class="area-selection-button-container hw-padding-left-1em hw-padding-right-1em"
                     fxFlexAlign="center">
                  <button mat-raised-button color="primary"
                          (click)="!isAreaDisabled(area) ? selectArea(area.areaId) : null" [disabled]="isAreaDisabled(area)">
                    {{t.shopping("select")}} <mat-icon iconPositionEnd class="mdi mdi-chevron-right"></mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </mat-grid-tile>
          }
        </mat-grid-list>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #group_selection>
  <div class="hw-block hw-100">
    <div fxFlex fxLayout="row" fxLayout.xs="column" fxLayout.sm="column">
      <div fxFlex="100">
        <mat-grid-list class="hw-100" [cols]="isMobile ? 1 : isTablet ? 2 : 4" gutterSize="10px" rowHeight="255px">
          @for (group of groupList; track group) {
          <mat-grid-tile>
            @if (isGroupDisabled(group)) {
            <div fxFlex="70" fxFlexAlign="center center" class="area-error-container hw-padding-1em">
              {{t.errors("ERR_ALL_TICKET_SOLD")}}
            </div>
            }
            <div class="mat-elevation-z8 area-card area-card-style"
                 [ngStyle]="{'opacity': isGroupDisabled(group) ? '0.3' : '' }">
              <!-- line 1 -->
              <div fxLayout="row" class="hw-100">
                <div fxFlex="100" fxLayout="row" class="area-icon-container hw-width-100">
                  <div fxFlex="auto" class="image-wrapper">
                    <img src={{getGroupImagePath(group)}} class="areakind-icon-style" alt="">
                  </div>
                  <span class="mdi mdi-information-outline more-description"
                        (click)="!isGroupDisabled(group) && group.language.description ? showTooltip(group.language.description) : null"
                        class="hw-margin-left-auto" [ngStyle]="{'opacity': group.language.description ? '' : '0.3' }">
                  </span>
                </div>
              </div>
              <!-- line 2 -->
              <div fxLayout="row">
                <div fxFlex="100" fxFlexAlign="center" class="area-name-container hw-width-100">
                  <span class="area-name-font">{{group.language.name}}</span>
                </div>
              </div>
              <!-- line 3 -->
              <div fxLayout="row">
                <div fxFlex="100" fxFlexAlign="center" class="area-name-container hw-width-100">
                  <!--<span [ngStyle]="areFullNessStyle(area.occupancy)" class="capacity-name-font">{{areFullNessText(area.occupancy)}}</span>-->
                </div>
              </div>
              <!-- line 4 -->
              <div fxLayout="row">
                <div fxFlex="100" class="area-selection-button-container hw-padding-left-1em hw-padding-right-1em"
                     fxFlexAlign="center">
                  <button mat-raised-button color="primary"
                          (click)="!isGroupDisabled(group) ? selectGroup(group.ticketGroupId) : null">
                    {{t.shopping("select")}} <mat-icon iconPositionEnd class="mdi mdi-chevron-right"></mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </mat-grid-tile>
          }
        </mat-grid-list>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #ticket_selection>
  <!-- header -->

  <div class="hw-block hw-100">
    <mat-grid-list class="hw-100 hw-ticket-row-style" [cols]="isMobile ? 1 : isTablet ? 2 : 4" gutterSize="10px"
                   rowHeight="340px">

      @for (ticket of ticketList; track ticket) {
      <mat-grid-tile>
        <div class="mat-elevation-z8 ticket-card">
          <div fxLayout="row wrap" class="blue-border-bottom ticket-row" [ngClass]="{'no-logo': !ticket.imageId}">
            <!-- row 1 icon, title -->
            @if (ticket.imageId) {
            <div fxFlex="20" class="background-pictogram"
                 [style.background-image]="'url(' + getTicketImagePath(ticket) + ')'">
            </div>
            }
            <!-- Ticket Name -->
            <div [ngStyle]="{ 'flex': ticket.imageId ? '0 0 60%' : '0 0 80%' }" class="ticket-name-container">
              <span class="ticket-name-font">{{ ticket.language.name }}</span>
            </div>
            <!-- Tooltip -->
            <div fxFlex="20" class="ticket-icon-container">
              <span class="mdi mdi-information-outline more-description"
                    (click)="ticket.language.description ? showTooltip(ticket.language.description) : null"
                    [ngStyle]="{'opacity': ticket.language.description ? '' : '0.3' }">
              </span>
            </div>
          </div>
          <div>
            <!-- row 2  ticket description  -->
            <div fxLayout="row">
              <div fxFlex="100" class="ticket-description-wrapper">
                <span class="ticket-description"> {{truncateString(ticket.language.description,105)}} </span>
              </div>
            </div>
            <!-- row 3  price, info button -->
            <div fxLayout="row" fxLayoutAlign="start center" class="hw-padding-top-1em">
              <div fxFlex="50">
                <div fxLayout="row" fxLayoutAlign="end center" class="add-circle-buttons">
                  <button (click)="decrement(ticket)" class="accessibility-button" tabindex="0" fxFlex="33"
                          fxFlexAlign="start">
                    <span class="hw-cursor mdi mdi-minus-circle-outline decrement"></span>
                  </button>
                  <div fxFlex="33" fxFlexAlign="center" class="price-amount-container">
                    <span class="price-amount">
                      {{ticket.quantity }}
                    </span>
                  </div>
                  <button (click)="increment(ticket)" class="accessibility-button increment-container" tabindex="0"
                          fxFlex="33" fxFlexAlign="end">
                    <span class="hw-cursor mdi mdi-plus-circle-outline  increment"></span>
                  </button>
                </div>
              </div>
              <div fxFlex="50" fxLayoutAlign="end center">
                <span class="price-label">
                  {{t.shopping("price")}}: {{ticket.price.price|number:undefined:currLocale}}
                  {{ticket.price.currency.symbol}}
                </span>
              </div>
            </div>
            <!-- row 4 plusminus and add to basket-->
            <div fxLayout="row">
              <div class="hw-width-100 hw-100 add-to-basket">
                <button color="primary" mat-raised-button (click)="addToBasket(ticket)"
                        class="add-to-basket-button hw-width-100">
                  <mat-icon iconPositionEnd class="mdi mdi-cart-plus"></mat-icon> {{t.shopping("add_to_basket")}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </mat-grid-tile>
      }
    </mat-grid-list>
  </div>

</ng-template>

<ng-template #show_basket>
  <div class="hw-block hw-100">
    <div fxLayout="row">
      <div fxFlex="100">
        <basket />
      </div>
    </div>
  </div>
</ng-template>

<ng-template #personal_data let-form="form">
  <div [formGroup]="form">
    <div class="hw-block">

      <!-- row 1: Name -->
      <div fxLayout="row wrap">
        <div class="group-header">
          {{t.paymentForm("nameGroupTitle")}}
        </div>
        <div fxFlex="100" fxFlex.xs="100" fxFlex.sm="100" fxFlex.md="50" fxFlex.lg="50" fxFlex.xl="50"
             class="hw-width-100 input-field-style">
          <mat-form-field appearance="outline" floatLabel="always" class="hw-width-100">
            <mat-label>{{t.paymentForm("firstName")}}</mat-label>
            <input type="text" [maxlength]="getPersonalDataFormMaxLength('FirstName')" matInput formControlName="FirstName"
                   name="FirstName" titlecase>
            @if (checkPersonalDataFormHasRequiredError('FirstName')) {
            <mat-error>
              {{t.errors("ERR_REQUIRED")}}
            </mat-error>
            }
            @if (checkPersonalDataFormHasServerError('FirstName')) {
            <mat-error>
              {{getPersonalDataFormServerError("FirstName")}}
            </mat-error>
            }
            @if (checkPersonalDataFormHasMaxLengthError('FirstName')) {
            <mat-error>
              {{getPersonalDataFormMaxLengthErrorMessage('FirstName')}}
            </mat-error>
            }
            @if (checkPersonalDataFormHasPatternError('FirstName')) {
            <mat-error>
              {{t.errors("ERR_PATTERN")}}
            </mat-error>
            }
          </mat-form-field>
        </div>

        <div fxFlex="100" fxFlex.xs="100" fxFlex.sm="100" fxFlex.md="50" fxFlex.lg="50" fxFlex.xl="50"
             class="hw-width-100 input-field-style">
          <mat-form-field appearance="outline" floatLabel="always" class="hw-width-100">
            <mat-label>{{t.paymentForm("lastName")}}</mat-label>
            <input type="text" [maxlength]="getPersonalDataFormMaxLength('LastName')" matInput formControlName="LastName"
                   name="LastName" titlecase>
            @if (checkPersonalDataFormHasRequiredError('LastName')) {
            <mat-error>
              {{t.errors("ERR_REQUIRED")}}
            </mat-error>
            }
            @if (checkPersonalDataFormHasServerError('LastName')) {
            <mat-error>
              {{getPersonalDataFormServerError("LastName")}}
            </mat-error>
            }
            @if (checkPersonalDataFormHasMaxLengthError('LastName')) {
            <mat-error>
              {{getPersonalDataFormMaxLengthErrorMessage('LastName')}}
            </mat-error>
            }
            @if (checkPersonalDataFormHasPatternError('LastName')) {
            <mat-error>
              {{t.errors("ERR_PATTERN")}}
            </mat-error>
            }
          </mat-form-field>
        </div>

      </div>

      <!-- row 2: Address -->
      <div fxLayout="row wrap">
        <div class="group-header">
          {{t.paymentForm("addressGroupTitle")}}
        </div>
        <div fxFlex="100" fxFlex.xs="100" fxFlex.sm="100" fxFlex.md="40" fxFlex.lg="40" fxFlex.xl="40"
             class="input-field-style">
          <mat-form-field appearance="outline" floatLabel="always" class="hw-width-100">
            <mat-label>{{t.paymentForm("countryCode")}}</mat-label>
            <input type="text" placeholder="" matInput required [formControl]="countryCodeFormControl"
                   [matAutocomplete]="countryCode" titlecase>
            @if(personalDataForm.controls['CountryCode'].value) {
            <button type="button" matSuffix mat-icon-button (click)="clearControl($event, personalDataForm, 'CountryCode')">
              <close-svg />
            </button>
            }
            <mat-autocomplete #countryCode="matAutocomplete" [displayWith]="displayCountriesDropdown.bind(this)">
              @for (country of filteredCountries | async; track country) {
              <mat-option [value]="country.iso2Code">
                <img [src]="country.flagUrl" height="15" class="hw-margin-right:10" alt="" />
                {{country.commonName}}
              </mat-option>
              }
            </mat-autocomplete>
            @if (checkPersonalDataFormHasRequiredError('CountryCode')) {
            <mat-error>
              {{t.errors("ERR_REQUIRED")}}
            </mat-error>
            }
            @if (checkAutocompleteValueIsValid('CountryCode')) {
            <mat-error>
              {{t.errors("ERR_INVALID_VALUE")}}
            </mat-error>
            }
            @if (checkPersonalDataFormHasServerError('CountryCode')) {
            <mat-error>
              {{getPersonalDataFormServerError("CountryCode")}}
            </mat-error>
            }
          </mat-form-field>
        </div>

        @if (isHungarySelected()) {
        <div fxFlex="100" fxFlex.xs="100" fxFlex.sm="100" fxFlex.md="60" fxFlex.lg="60" fxFlex.xl="60"
             class="input-field-style">
          <mat-form-field appearance="outline" floatLabel="always" class="hw-width-100">
            <mat-label>{{t.paymentForm("cityZip")}}</mat-label>
            <input type="text" placeholder="" matInput required [formControl]="cityZipFormControl"
                   [matAutocomplete]="cityZip">
            @if(personalDataForm.controls['CityZip'].value) {
            <button type="button" matSuffix mat-icon-button (click)="clearControl($event, personalDataForm, 'CityZip')">
              <close-svg />
            </button>
            }
            <mat-autocomplete #cityZip="matAutocomplete">
              @for (cityZip of filteredCityZips | async; track cityZip) {
              <mat-option [value]="cityZip.text">
                {{cityZip.zip}} - {{cityZip.city}}
              </mat-option>
              }
            </mat-autocomplete>
            @if (checkPersonalDataFormHasRequiredError('CityZip')) {
            <mat-error>
              {{t.errors("ERR_REQUIRED")}}
            </mat-error>
            }
            @if (checkAutocompleteValueIsValid('CityZip')) {
            <mat-error>
              {{t.errors("ERR_INVALID_VALUE")}}
            </mat-error>
            }
            @if (checkPersonalDataFormHasServerError('CityZip')) {
            <mat-error>
              {{getPersonalDataFormServerError("CityZip")}}
            </mat-error>
            }
          </mat-form-field>
        </div>
        }

        @if (!isHungarySelected()) {
        <div fxFlex="100" fxFlex.xs="100" fxFlex.sm="100" fxFlex.md="20" fxFlex.lg="20" fxFlex.xl="20"
             class="hw-width-100 input-field-style">
          <mat-form-field appearance="outline" floatLabel="always" class="hw-width-100">
            <mat-label>{{t.paymentForm("zipCode")}}</mat-label>
            <input type="text" [maxlength]="getPersonalDataFormMaxLength('ZipCode')" matInput formControlName="ZipCode" name="Zip">
            @if (checkPersonalDataFormHasRequiredError('ZipCode')) {
            <mat-error>
              {{t.errors("ERR_REQUIRED")}}
            </mat-error>
            }
            @if (checkPersonalDataFormHasServerError('ZipCode')) {
            <mat-error>
              {{getPersonalDataFormServerError("ZipCode")}}
            </mat-error>
            }
            @if (checkPersonalDataFormHasMaxLengthError('ZipCode')) {
            <mat-error>
              {{getPersonalDataFormMaxLengthErrorMessage('ZipCode')}}
            </mat-error>
            }
            @if (checkPersonalDataFormHasPatternError('ZipCode')) {
            <mat-error>
              {{t.errors("ERR_PATTERN")}}
            </mat-error>
            }
          </mat-form-field>
        </div>
        }

        @if (!isHungarySelected()) {
        <div fxFlex="100" fxFlex.xs="100" fxFlex.sm="100" fxFlex.md="40" fxFlex.lg="40" fxFlex.xl="40"
             class="hw-width-100 input-field-style">
          <mat-form-field appearance="outline" floatLabel="always" class="hw-width-100">
            <mat-label>{{t.paymentForm("city")}}</mat-label>
            <input type="text" [maxlength]="getPersonalDataFormMaxLength('City')" matInput formControlName="City" name="City" titlecase>
            @if (checkPersonalDataFormHasRequiredError('City')) {
            <mat-error>
              {{t.errors("ERR_REQUIRED")}}
            </mat-error>
            }
            @if (checkPersonalDataFormHasServerError('City')) {
            <mat-error>
              {{getPersonalDataFormServerError("City")}}
            </mat-error>
            }
            @if (checkPersonalDataFormHasMaxLengthError('City')) {
            <mat-error>
              {{getPersonalDataFormMaxLengthErrorMessage('City')}}
            </mat-error>
            }
            @if (checkPersonalDataFormHasPatternError('City')) {
            <mat-error>
              {{t.errors("ERR_PATTERN")}}
            </mat-error>
            }
          </mat-form-field>
        </div>
        }

        <div fxFlex.xs="100" fxFlex.sm="100" fxFlex.md="100" fxFlex.lg="100" fxFlex.xl="100"
             class="hw-width-100 input-field-style">
          <mat-form-field appearance="outline" floatLabel="always" class="hw-width-100">
            <mat-label>{{t.paymentForm("streetAndNumber")}}</mat-label>
            <input [maxlength]="getPersonalDataFormMaxLength('StreetAndNumber')" type="text" matInput formControlName="StreetAndNumber"
                   name="Address" titlecase>
            @if (checkPersonalDataFormHasRequiredError('StreetAndNumber')) {
            <mat-error>
              {{t.errors("ERR_REQUIRED")}}
            </mat-error>
            }
            @if (checkPersonalDataFormHasServerError('StreetAndNumber')) {
            <mat-error>
              {{getPersonalDataFormServerError("StreetAndNumber")}}
            </mat-error>
            }
            @if (checkPersonalDataFormHasMaxLengthError('StreetAndNumber')) {
            <mat-error>
              {{getPersonalDataFormMaxLengthErrorMessage('StreetAndNumber')}}
            </mat-error>
            }
            @if (checkPersonalDataFormHasPatternError('StreetAndNumber')) {
            <mat-error>
              {{t.errors("ERR_PATTERN")}}
            </mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <!-- row4 : taxnumber + eutaxnumber -->
      <div fxLayout="row wrap">
        <div class="group-header">
          {{t.paymentForm("invoiceDataGroupTitle")}}
        </div>
        <div fxFlex="100" fxFlex.xs="100" fxFlex.sm="100" fxFlex.md="100" fxFlex.lg="100" fxFlex.xl="100"
             class="hw-width-100 input-field-style">
          <mat-checkbox formControlName="PrivatePerson">{{t.paymentForm("privatePerson")}}</mat-checkbox>
        </div>
        @if (!getFormValue('PrivatePerson')) {
        <div fxFlex="100" fxFlex.xs="100" fxFlex.sm="100" fxFlex.md="100" fxFlex.lg="100" fxFlex.xl="100"
             class="hw-width-100 input-field-style">
          <mat-form-field appearance="outline" floatLabel="always" class="hw-width-100">
            <mat-label>{{t.paymentForm("companyName")}}</mat-label>
            <input type="text" [maxlength]="getPersonalDataFormMaxLength('CompanyName')" matInput formControlName="CompanyName"
                   titlecase>
            @if (checkPersonalDataFormHasRequiredError('CompanyName')) {
            <mat-error>
              {{t.errors("ERR_REQUIRED")}}
            </mat-error>
            }
            @if (checkPersonalDataFormHasServerError('CompanyName')) {
            <mat-error>
              {{getPersonalDataFormServerError("CompanyName")}}
            </mat-error>
            }
            @if (checkPersonalDataFormHasMaxLengthError('CompanyName')) {
            <mat-error>
              {{getPersonalDataFormMaxLengthErrorMessage('CompanyName')}}
            </mat-error>
            }
          </mat-form-field>
        </div>
        }
        @if (!getFormValue('PrivatePerson')) {
        <div fxFlex="100" fxFlex.xs="100" fxFlex.sm="100" fxFlex.md="50" fxFlex.lg="50" fxFlex.xl="50"
             class="hw-width-100 input-field-style">
          <mat-form-field appearance="outline" floatLabel="always" class="hw-width-100">
            <mat-label>{{t.paymentForm("taxNumber")}}</mat-label>
            <input type="text" [maxlength]="getPersonalDataFormMaxLength('TaxNumber')" matInput formControlName="TaxNumber"
                   name="TaxNumber">
            @if (checkPersonalDataFormHasRequiredError('TaxNumber')) {
            <mat-error>
              {{t.errors("ERR_REQUIRED")}}
            </mat-error>
            }
            @if (checkPersonalDataFormHasServerError('TaxNumber')) {
            <mat-error>
              {{getPersonalDataFormServerError("TaxNumber")}}
            </mat-error>
            }
            @if (checkPersonalDataFormHasMaxLengthError('TaxNumber')) {
            <mat-error>
              {{getPersonalDataFormMaxLengthErrorMessage('TaxNumber')}}
            </mat-error>
            }
            @if (checkPersonalDataFormHasPatternError('TaxNumber')) {
            <mat-error>
              {{t.errors("ERR_PATTERN")}}
            </mat-error>
            }
          </mat-form-field>
        </div>
        }
        @if (!getFormValue('PrivatePerson')) {
        <div fxFlex="100" fxFlex.xs="100" fxFlex.sm="100" fxFlex.md="50" fxFlex.lg="50" fxFlex.xl="50"
             class="hw-width-100 input-field-style">
          <mat-form-field appearance="outline" floatLabel="always" class="hw-width-100">
            <mat-label>{{t.paymentForm("euTaxNumber")}}</mat-label>
            <input type="text" [maxlength]="getPersonalDataFormMaxLength('EuTaxNumber')" matInput formControlName="EuTaxNumber"
                   name="EuTaxNumber">
            @if (checkPersonalDataFormHasServerError('EuTaxNumber')) {
            <mat-error>
              {{getPersonalDataFormMaxLengthErrorMessage("EuTaxNumber")}}
            </mat-error>
            }
          </mat-form-field>
        </div>
        }
      </div>

      <!-- row5 : email + telephone -->
      <div fxLayout="row wrap">
        <div class="group-header">
          {{t.paymentForm("notificationDataGroupTitle")}}
        </div>
        <div fxFlex="100" fxFlex.xs="100" fxFlex.sm="100" fxFlex.md="33" fxFlex.lg="33" fxFlex.xl="33"
             class="hw-width-100 input-field-style">
          <mat-form-field appearance="outline" floatLabel="always" class="hw-width-100">
            <mat-label>{{t.paymentForm("email")}}</mat-label>
            <input type="email" [maxlength]="getPersonalDataFormMaxLength('Email')" matInput formControlName="Email" name="Email"
                   (blur)="emailValueChanged($event)">
            @if (checkPersonalDataFormHasEmailError('Email')) {
            <mat-error>
              {{t.errors("ERR_EMAIL")}}
            </mat-error>
            }
            @if (checkPersonalDataFormHasRequiredError('Email')) {
            <mat-error>
              {{t.errors("ERR_REQUIRED")}}
            </mat-error>
            }
            @if (checkPersonalDataFormHasServerError('Email')) {
            <mat-error>
              {{getServerError("Email")}}
            </mat-error>
            }
            @if (checkPersonalDataFormHasMaxLengthError('Email')) {
            <mat-error>
              {{getPersonalDataFormMaxLengthErrorMessage("Email")}}
            </mat-error>
            }
          </mat-form-field>
        </div>

        <div fxFlex="100" fxFlex.xs="100" fxFlex.sm="100" fxFlex.md="33" fxFlex.lg="33" fxFlex.xl="33"
             class="hw-width-100 input-field-style">
          <mat-form-field appearance="outline" floatLabel="always" class="hw-width-100">
            <mat-label>{{t.paymentForm("confirmEmail")}}</mat-label>
            <input type="email" [maxlength]="getPersonalDataFormMaxLength('ConfirmEmail')" matInput formControlName="ConfirmEmail"
                   disable-paste>
            @if (checkPersonalDataFormHasEmailError('ConfirmEmail')) {
            <mat-error>
              {{t.errors("ERR_EMAIL")}}
            </mat-error>
            }
            @if (checkPersonalDataFormHasRequiredError('ConfirmEmail')) {
            <mat-error>
              {{t.errors("ERR_REQUIRED")}}
            </mat-error>
            }
            @if (checkPersonalDataFormHasServerError('ConfirmEmail')) {
            <mat-error>
              {{getPersonalDataFormServerError("ConfirmEmail")}}
            </mat-error>
            }
            @if (checkPersonalDataFormHasMaxLengthError('ConfirmEmail')) {
            <mat-error>
              {{getPersonalDataFormMaxLengthErrorMessage("ConfirmEmail")}}
            </mat-error>
            }
            @if (!checkPersonalDataFormHasEmailError('ConfirmEmail') && checkPersonalDataFormIsEmailMatch('ConfirmEmail')) {
            <mat-error>
              {{t.errors("ERR_EMAILMATCH")}}
            </mat-error>
            }
          </mat-form-field>
        </div>

        <div fxFlex="100" fxFlex.xs="100" fxFlex.sm="100" fxFlex.md="33" fxFlex.lg="33" fxFlex.xl="33"
             class="hw-width-100 input-field-style">
          <mat-form-field appearance="outline" floatLabel="always" class="hw-width-100">
            <mat-label>{{t.paymentForm("phoneNumber")}}</mat-label>
            <input type="tel" [maxlength]="getPersonalDataFormMaxLength('PhoneNumber')" matInput formControlName="PhoneNumber"
                   name="PhoneNumber">
            @if (checkPersonalDataFormHasServerError('PhoneNumber')) {
            <mat-error>
              {{getPersonalDataFormServerError("PhoneNumber")}}
            </mat-error>
            }
            @if (checkPersonalDataFormHasMaxLengthError('PhoneNumber')) {
            <mat-error>
              {{getPersonalDataFormMaxLengthErrorMessage("PhoneNumber")}}
            </mat-error>
            }
            @if (checkPersonalDataFormHasPatternError('PhoneNumber')) {
            <mat-error>
              {{t.errors("ERR_PATTERN")}}
            </mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <!-- row6: paymentoptions -->
      <div fxLayout="row wrap" class="hw-margin-bottom:30">
        <div class="group-header hw-display-flex hw-align-items-center">
          <span class="payment-options-group-title-text">{{t.paymentForm("paymentOptionsGroupTitle")}}</span>
          <img width="160" height="30" src="assets/icons/payment-options/nevogate_logo_blue.svg" title="Nevogate" alt="Nevogate">
        </div>
        <div fxFlex="100" fxFlex.xs="100" fxFlex.sm="100" fxFlex.md="100" fxFlex.lg="100" fxFlex.xl="100"
             class="hw-width-100 input-field-style">
          <mat-radio-group formControlName="PaymentOptionCode">
            @if (cardPaymentOptions.length>0) {
            <div>
              <div class="hw-width-100 group-sub-header">
                {{t.paymentForm("creditCardOption")}}
              </div>
              <div class="payment-option-position">
                @for (paymentoption of cardPaymentOptions; track paymentoption) {
                <div>
                  <mat-radio-button value="{{paymentoption.provider.value}}">
                    <div class="hw-align-items-center hw-display-flex">
                      <a [attr.href]="paymentoption.url" target="_blank" rel="noopener noreferrer">
                        <img [class]="'payment-options-icon ' + paymentoption.provider.value" width="70" alt=""
                             [src]="getPaymentOptionIconUrlByType(paymentoption.provider.value)" />
                      </a>
                      <span class="hw-margin-left-10px">{{paymentoption.provider.name}}</span>
                    </div>
                  </mat-radio-button>
                </div>
                }
              </div>
            </div>
            }
            @if (szepPaymentOptions.length > 0 && cardPaymentOptions.length > 0) {
            <mat-divider class="szep-payment-option"></mat-divider>
            }

            @if (szepPaymentOptions.length > 0) {
            <div class="hw-width-100">
              <div class="hw-width-100 group-sub-header hw-padding-top-1em">
                {{t.paymentForm("szepCardOption")}}
              </div>
              <div class="szep-payment-position">
                @for (paymentoption of szepPaymentOptions; track paymentoption) {
                <div>
                  <mat-radio-button value="{{paymentoption.provider.value}}">
                    <div class="hw-display-flex hw-align-items-center">
                      <a [attr.href]="paymentoption.url" target="_blank" rel="noopener noreferrer">
                        <img width="70" [src]="getPaymentOptionIconUrlByType(paymentoption.provider.value)" alt="" />
                      </a>
                      <span class="hw-margin-left-10px">{{paymentoption.provider.name}}</span>
                    </div>
                  </mat-radio-button>
                </div>
                }
              </div>
            </div>
            }
          </mat-radio-group>
        </div>
        @if (checkPersonalDataFormHasRequiredError('PaymentOptionCode')) {
        <mat-error>
          {{t.errors("ERR_PAYMENTOPTION_REQUIRED")}}
        </mat-error>
        }
      </div>
    </div>
  </div>
</ng-template>

<ng-template #summary let-form="form">
  <div [formGroup]="form" class="hw-width-100">
    <mat-card appearance="outlined" class="summary-mat-card">
      <mat-card-content class="hw-padding-top-0">
        <div class="group-header">
          {{t.steps("invoice_data_header")}}
        </div>
        <div fxLayout="row wrap">
          <div fxFlex.xs="{{sptw1_xs}}" fxFlex.sm="{{sptw1}}" fxFlex.md="{{sptw1}}" fxFlex.lg="{{sptw1}}"
               fxFlex.xl="{{sptw1}}" class="summary-title">{{t.paymentForm("nameGroupTitle")}}</div>
          <div fxFlex.xs="{{sptw2_xs}}" fxFlex.sm="{{sptw2}}" fxFlex.md="{{sptw2}}" fxFlex.lg="{{sptw2}}"
               fxFlex.xl="{{sptw2}}" class="hw-width-100 input-field-style">
            {{getFormValue('FirstName')}}
            {{getFormValue('LastName')}}
          </div>
        </div>
        <div fxLayout="row wrap">
          <div fxFlex.xs="{{sptw1_xs}}" fxFlex.sm="{{sptw1}}" fxFlex.md="{{sptw1}}" fxFlex.lg="{{sptw1}}"
               fxFlex.xl="{{sptw1}}" class="summary-title">{{t.paymentForm("addressGroupTitle")}}</div>
          <div fxFlex.xs="{{sptw2_xs}}" fxFlex.sm="{{sptw2}}" fxFlex.md="{{sptw2}}" fxFlex.lg="{{sptw2}}"
               fxFlex.xl="{{sptw2}}" class="hw-width-100 input-field-style">
            {{displayCountriesDropdown(getFormValue('CountryCode'))}}, {{getFormValue('ZipCode')}}
            {{getFormValue('City')}} {{getFormValue('StreetAndNumber')}}
          </div>
        </div>
        <div fxLayout="row wrap">
          <div fxFlex.xs="{{sptw1_xs}}" fxFlex.sm="{{sptw1}}" fxFlex.md="{{sptw1}}" fxFlex.lg="{{sptw1}}"
               fxFlex.xl="{{sptw1}}" class="summary-title">{{t.paymentForm("privatePerson")}}</div>
          <div fxFlex.xs="{{sptw2_xs}}" fxFlex.sm="{{sptw2}}" fxFlex.md="{{sptw2}}" fxFlex.lg="{{sptw2}}"
               fxFlex.xl="{{sptw2}}" class="hw-width-100 input-field-style">
            {{getFormValue('PrivatePerson') ? t.common("yes"): t.common("no")}}
          </div>
        </div>
        @if (!getFormValue('PrivatePerson')) {
        <div fxLayout="row wrap">
          <div fxFlex.xs="{{sptw1_xs}}" fxFlex.sm="{{sptw1}}" fxFlex.md="{{sptw1}}" fxFlex.lg="{{sptw1}}"
               fxFlex.xl="{{sptw1}}" class="summary-title">{{t.paymentForm("invoiceDataGroupTitle")}}</div>
          <div fxFlex.xs="{{sptw2_xs}}" fxFlex.sm="{{sptw2}}" fxFlex.md="{{sptw2}}" fxFlex.lg="{{sptw2}}"
               fxFlex.xl="{{sptw2}}" class="hw-width-100 input-field-style">
            {{t.paymentForm("companyName")}}: {{getFormValue('CompanyName')}} <br />
            {{t.paymentForm("taxNumber")}}: {{getFormValue('TaxNumber')}} <br />
            {{t.paymentForm("euTaxNumber")}}: {{getFormValue('EuTaxNumber')}}
          </div>
        </div>
        }
        <div fxLayout="row wrap">
          <div fxFlex.xs="{{sptw1_xs}}" fxFlex.sm="{{sptw1}}" fxFlex.md="{{sptw1}}" fxFlex.lg="{{sptw1}}"
               fxFlex.xl="{{sptw1}}" class="summary-title">
            {{t.paymentForm("notificationDataGroupTitle")}}
          </div>
          <div fxFlex.xs="{{sptw2_xs}}" fxFlex.sm="{{sptw2}}" fxFlex.md="{{sptw2}}" fxFlex.lg="{{sptw2}}"
               fxFlex.xl="{{sptw2}}" class="hw-width-100 input-field-style">
            {{t.paymentForm("email")}}:
            {{getFormValue('Email')}} <br /> {{t.paymentForm("phoneNumber")}}:
            {{getFormValue('PhoneNumber')}}
          </div>
        </div>
        <div fxLayout="row wrap">
          <div fxFlex.xs="{{sptw1_xs}}" fxFlex.sm="{{sptw1}}" fxFlex.md="{{sptw1}}" fxFlex.lg="{{sptw1}}"
               fxFlex.xl="{{sptw1}}" class="summary-title">{{t.paymentForm("paymentOptionsGroupTitle")}}</div>
          <div fxFlex.xs="{{sptw2_xs}}" fxFlex.sm="{{sptw2}}" fxFlex.md="{{sptw2}}" fxFlex.lg="{{sptw2}}"
               fxFlex.xl="{{sptw2}}" class="hw-width-100 input-field-style">
            {{getSelectedPaymentOptionLabel()}}
          </div>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card appearance="outlined" class="summary-mat-card">
      <mat-card-content class="hw-padding-top-0">
        <div class="group-header">
          {{t.steps("show_basket_header")}}
        </div>
        <div class="hw-block hw-100">
          <div fxLayout="row">
            <div fxFlex="100">
              <basket [readonlyMode]="true" />
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card appearance="outlined" class="center center" class="mat-card-outlined-style hw-roboto">
      <mat-card-content>
        <div fxFlex="100" fxLayoutAlign="center center">
          <div class="hw-block hw-100" [innerHTML]="getbookingHoldTimeForCapacityCheckWarningText() | safeHtml">
          </div>
        </div>
      </mat-card-content>
    </mat-card>
    <div fxLayout="row wrap" class="hw-margin-bottom-1rem">
      <div fxFlex="100" fxFlex.xs="100" fxFlex.sm="100" fxFlex.md="100" fxFlex.lg="100" fxFlex.xl="100"
           class="hw-width-100 input-field-checkbox-style">
        <mat-checkbox formControlName="acceptPrivacyPolicy">
          <div [innerHTML]="getConditionText('PRIVACY_POLICY') | safeHtml"></div>
        </mat-checkbox>
        <div class="mat-mdc-form-field-error-wrapper">
          @if (checkFormHasRequiredError(summaryForm, 'acceptPrivacyPolicy')) {
          <mat-error>
            {{t.errors("ERR_POLICY_REQUIRED")}}<br /><br />
          </mat-error>
          }
        </div>
      </div>

      <div fxFlex="100" fxFlex.xs="100" fxFlex.sm="100" fxFlex.md="100" fxFlex.lg="100" fxFlex.xl="100"
           class="hw-width-100 input-field-checkbox-style">
        <mat-checkbox formControlName="acceptAFSZ">
          <div [innerHTML]="getConditionText('GENERAL_TERMS_CONDITIONS') | safeHtml"></div>
        </mat-checkbox>
        <div class="mat-mdc-form-field-error-wrapper">
          @if (checkFormHasRequiredError(summaryForm, 'acceptAFSZ')) {
          <mat-error>
            {{t.errors("ERR_POLICY_REQUIRED")}}
          </mat-error>
          }
        </div>
      </div>

      @if (getFormValue('PaymentOptionCode') === 'OTPSimple') {
      <div fxFlex="100" fxFlex.xs="100" fxFlex.sm="100" fxFlex.md="100" fxFlex.lg="100" fxFlex.xl="100"
           class="hw-width-100 input-field-checkbox-style">
        <mat-checkbox formControlName="acceptOTPSimple">
          <div [innerHTML]="getConditionText('SIMPLEPAY_DATA_TRANSFER_STATEMENT') | safeHtml"></div>
        </mat-checkbox>
        <div class="mat-mdc-form-field-error-wrapper">
          @if (checkFormHasRequiredError(summaryForm, 'acceptOTPSimple')) {
          <mat-error>
            {{t.errors("ERR_POLICY_REQUIRED")}}
          </mat-error>
          }
        </div>
      </div>
      }

    </div>
  </div>
</ng-template>